// Tabela de caracteres do Pokémon da 3ª geração (charmap.txt do pret/pokefirered).
// Só o necessário para nomes: letras (com os acentos que a fonte do jogo tem),
// números e um pouco de pontuação. 0xFF termina a string.

export const EOS = 0xff;

const ENCODE = new Map<string, number>();
for (let i = 0; i < 26; i++) {
  ENCODE.set(String.fromCharCode(65 + i), 0xbb + i); // A-Z
  ENCODE.set(String.fromCharCode(97 + i), 0xd5 + i); // a-z
}
for (let i = 0; i < 10; i++) ENCODE.set(String(i), 0xa1 + i);
const EXTRA: [string, number][] = [
  [' ', 0x00], ['À', 0x01], ['Á', 0x02], ['Â', 0x03], ['Ç', 0x04], ['È', 0x05], ['É', 0x06], ['Ê', 0x07],
  ['Ë', 0x08], ['Ì', 0x09], ['Î', 0x0b], ['Ï', 0x0c], ['Ò', 0x0d], ['Ó', 0x0e], ['Ô', 0x0f], ['Ù', 0x11],
  ['Ú', 0x12], ['Û', 0x13], ['Ñ', 0x14], ['à', 0x16], ['á', 0x17], ['ç', 0x19], ['è', 0x1a], ['é', 0x1b],
  ['ê', 0x1c], ['ë', 0x1d], ['ì', 0x1e], ['î', 0x20], ['ï', 0x21], ['ò', 0x22], ['ó', 0x23], ['ô', 0x24],
  ['ù', 0x26], ['ú', 0x27], ['û', 0x28], ['ñ', 0x29], ['Í', 0x5a], ['â', 0x68], ['í', 0x6f],
  ['!', 0xab], ['?', 0xac], ['.', 0xad], ['-', 0xae], ['…', 0xb0], ["'", 0xb4], ['’', 0xb4],
  ['♂', 0xb5], ['♀', 0xb6], [',', 0xb8], ['/', 0xba],
  // Só existem na nossa ROM (posições vagas da fonte; ver traducao/fonte_ptbr.py)
  ['ã', 0x18], ['õ', 0x1f], ['Ã', 0x0a], ['Õ', 0x2f],
];
for (const [char, code] of EXTRA) ENCODE.set(char, code);

const DECODE = new Map<number, string>();
for (const [char, code] of ENCODE) if (!DECODE.has(code)) DECODE.set(code, char);

// A fonte original não tem til (ã/õ): nela, viram a/o. A nossa ROM traduzida tem.
const FALLBACK: Record<string, string> = { ü: 'u', Ü: 'U' };
const FALLBACK_SEM_TIL: Record<string, string> = { ...FALLBACK, ã: 'a', õ: 'o', Ã: 'A', Õ: 'O' };
let tilde = false;

/** A ROM em uso tem as letras com til? */
export function setTildeSupport(enabled: boolean): void {
  tilde = enabled;
}

export const hasTildeSupport = (): boolean => tilde;

/** Deixa só o que o jogo consegue escrever (troca ã→a etc. e descarta o resto). */
export function toGameText(text: string, maxLength: number): string {
  let out = '';
  const fallback = tilde ? FALLBACK : FALLBACK_SEM_TIL;
  for (const raw of text) {
    const char = fallback[raw] ?? raw;
    if (!ENCODE.has(char)) continue;
    if (out.length >= maxLength) break;
    out += char;
  }
  return out;
}

/** Codifica para bytes do jogo, completando com 0xFF até `size`. */
export function encodeGameText(text: string, size: number): Uint8Array {
  const bytes = new Uint8Array(size).fill(EOS);
  let i = 0;
  for (const char of text) {
    const code = ENCODE.get(char);
    if (code === undefined) continue;
    if (i >= size - 1) break; // sempre sobra o terminador
    bytes[i++] = code;
  }
  return bytes;
}

export function decodeGameText(bytes: Uint8Array): string {
  let out = '';
  for (const byte of bytes) {
    if (byte === EOS) break;
    out += DECODE.get(byte) ?? '?';
  }
  return out;
}
